const DEFAULT_MOTION_TOKENS = Object.freeze({
  duration50: 0.05,
  duration80: 0.08,
  duration100: 0.1,
  duration120: 0.12,
  duration150: 0.15,
  duration180: 0.18,
  duration200: 0.2,
  duration250: 0.25,
  duration300: 0.3,
  duration350: 0.35,
  duration400: 0.4,
  duration450: 0.45,
  duration500: 0.5,
  duration550: 0.55,
  duration600: 0.6,
  duration650: 0.65,
  duration700: 0.7,
  duration750: 0.75,
  duration800: 0.8,
  duration850: 0.85,
  duration1200: 1.2,
  duration1250: 1.25,
  duration2200: 2.2,
  duration5000: 5,
});

const parseCssTimeToSeconds = (value) => {
  const raw = String(value || "").trim();
  if (!raw) return NaN;
  if (raw.endsWith("ms")) {
    const numeric = Number.parseFloat(raw.slice(0, -2));
    return Number.isFinite(numeric) ? numeric / 1000 : NaN;
  }
  if (raw.endsWith("s")) {
    const numeric = Number.parseFloat(raw.slice(0, -1));
    return Number.isFinite(numeric) ? numeric : NaN;
  }
  const numeric = Number.parseFloat(raw);
  return Number.isFinite(numeric) ? numeric : NaN;
};

const resolveMotionToken = (style, name, fallback) => {
  const value = parseCssTimeToSeconds(style.getPropertyValue(name));
  return Number.isFinite(value) ? value : fallback;
};

export const motionTokens = (() => {
  if (
    typeof window === "undefined" ||
    typeof document === "undefined" ||
    typeof window.getComputedStyle !== "function"
  ) {
    return DEFAULT_MOTION_TOKENS;
  }

  const style = window.getComputedStyle(document.documentElement);
  const get = (name, fallback) => resolveMotionToken(style, name, fallback);

  return Object.freeze({
    duration50: get("--motion-duration-50", DEFAULT_MOTION_TOKENS.duration50),
    duration80: get("--motion-duration-80", DEFAULT_MOTION_TOKENS.duration80),
    duration100: get("--motion-duration-100", DEFAULT_MOTION_TOKENS.duration100),
    duration120: get("--motion-duration-120", DEFAULT_MOTION_TOKENS.duration120),
    duration150: get("--motion-duration-150", DEFAULT_MOTION_TOKENS.duration150),
    duration180: get("--motion-duration-180", DEFAULT_MOTION_TOKENS.duration180),
    duration200: get("--motion-duration-200", DEFAULT_MOTION_TOKENS.duration200),
    duration250: get("--motion-duration-250", DEFAULT_MOTION_TOKENS.duration250),
    duration300: get("--motion-duration-300", DEFAULT_MOTION_TOKENS.duration300),
    duration350: get("--motion-duration-350", DEFAULT_MOTION_TOKENS.duration350),
    duration400: get("--motion-duration-400", DEFAULT_MOTION_TOKENS.duration400),
    duration450: get("--motion-duration-450", DEFAULT_MOTION_TOKENS.duration450),
    duration500: get("--motion-duration-500", DEFAULT_MOTION_TOKENS.duration500),
    duration550: get("--motion-duration-550", DEFAULT_MOTION_TOKENS.duration550),
    duration600: get("--motion-duration-600", DEFAULT_MOTION_TOKENS.duration600),
    duration650: get("--motion-duration-650", DEFAULT_MOTION_TOKENS.duration650),
    duration700: get("--motion-duration-700", DEFAULT_MOTION_TOKENS.duration700),
    duration750: get("--motion-duration-750", DEFAULT_MOTION_TOKENS.duration750),
    duration800: get("--motion-duration-800", DEFAULT_MOTION_TOKENS.duration800),
    duration850: get("--motion-duration-850", DEFAULT_MOTION_TOKENS.duration850),
    duration1200: get("--motion-duration-1200", DEFAULT_MOTION_TOKENS.duration1200),
    duration1250: get("--motion-duration-1250", DEFAULT_MOTION_TOKENS.duration1250),
    duration2200: get("--motion-duration-2200", DEFAULT_MOTION_TOKENS.duration2200),
    duration5000: get("--motion-duration-5000", DEFAULT_MOTION_TOKENS.duration5000),
  });
})();
